"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllDataProps = exports.getAllAriaProps = void 0;
var getAllAriaProps = function (props) {
    return filterPropsByNameRegex(props, /^aria-/i);
};
exports.getAllAriaProps = getAllAriaProps;
var getAllDataProps = function (props, smContext) {
    if (smContext.debug) {
        return filterPropsByNameRegex(props, /^data-/i);
    }
    return undefined;
};
exports.getAllDataProps = getAllDataProps;
var filterPropsByNameRegex = function (props, rx) {
    return Object.keys(props)
        .filter(function (k) { return null !== k.match(rx); })
        .reduce(function (c, k) {
        var _a;
        return (__assign(__assign({}, c), (_a = {}, _a[k] = props[k], _a)));
    }, {});
};
//# sourceMappingURL=propsFilter.js.map